"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlockFace = exports.airResistance = exports.projectileGravity = exports.trajectoryInfo = void 0;
exports.trajectoryInfo = {
    bow: { v0: 3, g: 0.05, ph: 1.62 },
    crossbow: { v0: 3.15, g: 0.05, ph: 1.62 },
    crossbow_firework: { v0: 1.6, g: 0.00, ph: 1.62 },
    trident: { v0: 2.5, g: 0.05, ph: 1.62 },
    snowball: { v0: 1.5, g: 0.04, ph: 1.52 },
    egg: { v0: 1.5, g: 0.04, ph: 1.52 },
    ender_pearl: { v0: 1.5, g: 0.0375, ph: 1.52 },
    splash_potion: { v0: 0.4, g: 0.03, ph: 1.52 },
};
exports.projectileGravity = {
    arrow: 0.05,
    trident: 0.05,
    egg: 0.04,
    snowball: 0.04,
    ender_pearl: 0.04,
    splash_potion: 0.03,
    firework_rocket: 0.00,
};
exports.airResistance = {
    y: 0.01,
    h: 0.01
};
var BlockFace;
(function (BlockFace) {
    BlockFace[BlockFace["UNKNOWN"] = -999] = "UNKNOWN";
    BlockFace[BlockFace["BOTTOM"] = 0] = "BOTTOM";
    BlockFace[BlockFace["TOP"] = 1] = "TOP";
    BlockFace[BlockFace["NORTH"] = 2] = "NORTH";
    BlockFace[BlockFace["SOUTH"] = 3] = "SOUTH";
    BlockFace[BlockFace["WEST"] = 4] = "WEST";
    BlockFace[BlockFace["EAST"] = 5] = "EAST";
})(BlockFace = exports.BlockFace || (exports.BlockFace = {}));
